import { Box, Center, Flex, Heading, Image, Link, ListItem, Text, UnorderedList } from "@chakra-ui/react";

const flagAddresses = {
  "ukFlag": "https://flagcdn.com/h20/gb.png",
  "usFlag": "https://flagcdn.com/h20/us.png",
  "euFlag": "https://flagcdn.com/h20/eu.png"
};

function SustainableFinanceRegulationsBox({ text, flag, contentTitle }) {
  return <Box>
    <Center pb={5}>
      <Image src={flagAddresses[flag]} pr={3} />
      <Heading size="md" color="esg_gray.200"> {contentTitle}</Heading>
    </Center>
    <Flex flex={1} direction="column" border="1px" borderRadius={10} padding={5}>
      {text.map(item => {
          return <Flex key={`regulations-box-container-${contentTitle}-${item.header}`} flex={1} direction="column">
            <UnorderedList>
              <ListItem>
                <Heading size="xs">
                  {item.header}
                </Heading>
              </ListItem>
              {item.points.map(point => {
                  return <UnorderedList
                    key={`regulations-box-point-${contentTitle}-${point.point}-${point.status ?? point.link}`}
                  >
                    <ListItem>
                      <Text fontSize="sm">
                        <b>{point.point}</b> {point.status ??
                        <Link textColor="blue.600" href={point.link} isExternal>here</Link>}
                      </Text>
                    </ListItem>
                  </UnorderedList>;
                }
              )}
            </UnorderedList>
          </Flex>;
        }
      )}
    </Flex>
  </Box>;
}

export default SustainableFinanceRegulationsBox;